module.exports = __webpack_public_path__ + "static/media/chat10.138239a9.svg";